import api from './api'

class InfoService {
    // 获取所有信息类型
    static async getInfoTypes() {
        const response = await api.get('/infogather/get_info_types/')
        return response.data
    }

    // 获取所有人员信息
    static async getPeople(params = {}) {
        const response = await api.get('/infogather/get_people/', { params })
        return response.data
    }

    // 获取所有信息
    static async getInfos(params = {}) {
        const response = await api.get('/infogather/get_infos/', { params })
        return response.data
    }

    // 解析原始信息
    static async parseInfo(data) {
        const response = await api.post('/infogather/parse_info/', data)
        return response.data
    }

    // 保存解析后的信息
    static async saveParsedInfo(data) {
        const response = await api.post('/infogather/save_parsed_info/', data)
        return response.data
    }

    // 检查信息是否重复
    static async checkDuplicate(data) {
        const response = await api.post('/infogather/check_duplicate/', data)
        return response.data
    }

    // 创建信息类型
    static async createInfoType(data) {
        const response = await api.post('/infogather/create_info_type/', data)
        return response.data
    }

    // 创建人员
    static async createPeople(data) {
        const response = await api.post('/infogather/create_people/', data)
        return response.data
    }

    // 更新人员
    static async updatePeople(id, data) {
        // 将ID添加到数据对象中
        const requestData = { ...data, id: id };
        const response = await api.post('/infogather/update_people/', requestData)
        return response.data
    }

    // 删除人员
    static async deletePeople(id) {
        const response = await api.delete(`/infogather/delete_people/${id}/`)
        return response.data
    }

    // 创建信息
    static async createInfo(data) {
        const response = await api.post('/infogather/create_info/', data)
        return response.data
    }

    // 更新信息
    static async updateInfo(id, data) {
        // 将ID添加到数据对象中
        const requestData = { ...data, id: id };
        const response = await api.post('/infogather/update_info/', requestData)
        return response.data
    }

    // 获取单个信息
    static async getInfo(id) {
        const response = await api.post('/infogather/get_info/', { id: id })
        return response.data
    }

    // 获取单个人员及其关联信息
    static async getPeopleWithInfos(id) {
        const response = await api.post('/infogather/get_people_with_infos/', { id: id })
        return response.data
    }

    // 删除信息
    static async deleteInfo(id) {
        const response = await api.delete(`/infogather/delete_info/${id}/`)
        return response.data
    }
}

export default InfoService